// src/data/projects.js
export const projectsData = [
  {
    id: 1,
    title: {
      fr: "Faroty Crowdfunding",
      en: "Faroty Crowdfunding"
    },
    description: {
      fr: "Plateforme de financement participatif pensée pour le marché africain",
      en: "Crowdfunding platform designed for the African market"
    },
    image: "/assets/images/faroty-crowdfunding.png",
    gallery: [
      "/assets/images/faroty-crowdfunding.png",
      "/assets/images/faroty-crowdfunding-detail1.png",
      "/assets/images/faroty-crowdfunding-detail2.jpg"
    ],
    tags: ["Spring Boot", "Next.js", "Microservices", "PostgreSQL", "Mobile Money"],
    longDescription: {
      fr: "Faroty Crowdfunding est une plateforme complète de financement participatif conçue et développée de A à Z pour le marché africain. Elle permet à tout porteur de projet au Cameroun et au-delà de lancer des campagnes de financement avec des outils adaptés au contexte local : paiement Mobile Money (MTN, Orange), système de récompenses pour les contributeurs, analytics en temps réel et gestion complète du cycle de vie des campagnes. Développée avec Spring Boot en architecture microservices pour le backend et Next.js pour le frontend.",
      en: "Faroty Crowdfunding is a complete crowdfunding platform designed and developed from scratch for the African market. It allows any project holder in Cameroon and beyond to launch fundraising campaigns with tools adapted to the local context: Mobile Money payments (MTN, Orange), contributor reward system, real-time analytics and complete campaign lifecycle management. Built with Spring Boot microservices architecture for the backend and Next.js for the frontend."
    },
    features: {
      fr: [
        "Création et publication de campagnes (projets, solidarité, communautés)",
        "Paiement via Mobile Money (MTN, Orange) avec confirmation webhook",
        "Système de récompenses avec gestion des stocks pour les contributeurs",
        "Suivi des livraisons de récompenses pour chaque contributeur",
        "Dashboard analytics complet (conversions, démographie, sources de trafic)",
        "Recherche avancée avec filtres, facettes et score de pertinence",
        "Système de commentaires, mentions et mises à jour de campagne",
        "Notifications automatiques à chaque étape du cycle de vie",
        "Sécurité JWT + architecture microservices scalable"
      ],
      en: [
        "Campaign creation and publication (projects, solidarity, communities)",
        "Mobile Money payments (MTN, Orange) with webhook confirmation",
        "Contributor reward system with stock management",
        "Reward delivery tracking for each contributor",
        "Full analytics dashboard (conversions, demographics, traffic sources)",
        "Advanced search with filters, facets and relevance scoring",
        "Comments, mentions and campaign updates system",
        "Automatic notifications at each lifecycle step",
        "JWT security + scalable microservices architecture"
      ]
    },
    technologies: [
      "Spring Boot (architecture microservices, API REST)",
      "Next.js (frontend)",
      "PostgreSQL",
      "JWT pour l'authentification",
      "Mobile Money (MTN, Orange) avec gestion de webhooks",
      "Docker pour le déploiement",
      "Système de notifications (email, push)"
    ],
    githubLink: "https://github.com/igorvannel",
    demoLink: "https://crowdfunding.faroty.com/"
  },
  {
    id: 2,
    title: {
      fr: "Application SocialBoost",
      en: "SocialBoost Application"
    },
    description: {
      fr: "Plateforme pour augmenter sa visibilité sur les réseaux sociaux",
      en: "Platform to increase your visibility on social media"
    },
    image: "/assets/images/project1.png",
    gallery: [
      "/assets/images/project1.png",
      "/assets/images/project1-detail1.jpg",
      "/assets/images/project1-detail2.jpg"
    ],
    tags: ["Spring Boot", "React JS", "React Native", "PostgreSQL", "Docker"],
    longDescription: {
      fr: "Une plateforme complète permettant aux utilisateurs d'augmenter leur visibilité sur les réseaux sociaux. Développée avec Spring Boot pour le backend, React JS pour le frontend web et React Native pour l'application mobile. L'application offre une expérience utilisateur fluide avec un design responsive et des fonctionnalités avancées pour gérer et optimiser sa présence sur les réseaux sociaux.",
      en: "A comprehensive platform allowing users to increase their visibility on social networks. Developed with Spring Boot for the backend, React JS for the web frontend and React Native for the mobile application. The application offers a smooth user experience with responsive design and advanced features to manage and optimize social media presence."
    },
    features: {
      fr: [
        "Authentification et gestion des profils utilisateurs",
        "Planification et programmation de publications",
        "Analyse de performance et statistiques",
        "Suggestions de contenu personnalisées",
        "Synchronisation multi-plateformes",
        "Tableau de bord intuitif"
      ],
      en: [
        "Authentication and user profile management",
        "Post planning and scheduling",
        "Performance analysis and statistics",
        "Personalized content suggestions",
        "Multi-platform synchronization",
        "Intuitive dashboard"
      ]
    },
    technologies: [
      "Spring Boot", "React JS", "React Native", "PostgreSQL",
      "Docker", "JWT", "REST API", "VPS Deployment"
    ],
    githubLink: "https://github.com/igorvannel",
    demoLink: "https://social-boost-web.vercel.app/"
  },
  {
    id: 3,
    title: {
      fr: "TrustPay - Plateforme d'Escrow Sécurisée",
      en: "TrustPay - Secure Escrow Platform"
    },
    description: {
      fr: "Service d'intermédiaire de confiance pour sécuriser les transactions en ligne en Afrique",
      en: "Trusted intermediary service to secure online transactions in Africa"
    },
    image: "/assets/images/project 2.png",
    gallery: [
      "/assets/images/project2-detail 22.jpg",
      "/assets/images/project2-detail 21.png",
      "/assets/images/project2-detail 2.png"
    ],
    tags: ["Spring Boot", "Microservices", "React", "React Native", "PostgreSQL", "Docker"],
    longDescription: {
      fr: "TrustPay est une application d'escrow (séquestre) sécurisée qui sert d'intermédiaire de confiance entre acheteurs et vendeurs au Cameroun et en Afrique. Dans un contexte où la confiance est un frein majeur aux transactions en ligne, TrustPay résout le problème du dilemme acheteur-vendeur : l'acheteur ne souhaite pas payer avant réception, et le vendeur refuse d'expédier sans paiement. La plateforme sécurise les fonds de l'acheteur jusqu'à validation de la transaction, tout en garantissant au vendeur que le paiement est disponible avant expédition.",
      en: "TrustPay is a secure escrow application that serves as a trusted intermediary between buyers and sellers in Cameroon and Africa. In a context where trust is a major obstacle to online transactions, TrustPay solves the buyer-seller dilemma: the buyer does not want to pay before receiving the product, while the seller refuses to ship without payment. The platform secures the buyer's funds until the transaction is validated, while guaranteeing the seller that payment is available before shipping."
    },
    features: {
      fr: [
        "Système KYC à plusieurs niveaux selon montant des transactions",
        "Gestion complète du processus d'escrow (dépôt, expédition, validation, libération)",
        "Intégration avec services de paiement locaux (MTN Mobile Money, Orange Money)",
        "Système de résolution des litiges à plusieurs niveaux",
        "Mécanisme de réputation et d'évaluation des utilisateurs",
        "Applications web et mobile avec support pour zones à faible connectivité"
      ],
      en: [
        "Multi-level KYC system based on transaction amount",
        "Complete escrow process management (deposit, shipping, validation, release)",
        "Integration with local payment services (MTN Mobile Money, Orange Money)",
        "Multi-level dispute resolution system",
        "User reputation and rating mechanism",
        "Web and mobile applications with support for low connectivity areas"
      ]
    },
    technologies: [
      "Architecture microservices (Spring Boot, Spring Cloud Gateway)",
      "React et React Native pour les applications web et mobile",
      "PostgreSQL pour les données transactionnelles",
      "MongoDB pour les données non structurées",
      "Kafka pour la messagerie entre services",
      "Docker et Kubernetes pour le déploiement",
      "JWT et authentification à deux facteurs pour la sécurité"
    ],
    githubLink: "https://github.com/igorvannel",
    demoLink: "#"
  },
  {
    id: 4,
    title: {
      fr: "SMSGatewayEmulator - Service SaaS",
      en: "SMSGatewayEmulator - SaaS Service"
    },
    description: {
      fr: "Solution d'émulation de passerelles SMS commerciales avec modèle économique freemium",
      en: "Commercial SMS gateway emulation solution with freemium business model"
    },
    image: "/assets/images/project 3.jpg",
    gallery: [
      "/assets/images/project 3.jpg",
      "/assets/images/project3-detail1.jpg",
      "/assets/images/project3-detail2.jpg"
    ],
    tags: ["React Native", "Expo", "Spring Boot", "PostgreSQL", "SaaS"],
    longDescription: {
      fr: "SMSGatewayEmulator est une application mobile développée avec React Native et Expo qui émule le fonctionnement des passerelles SMS commerciales coûteuses comme Twilio et Vonage. Cette solution offre une alternative économique pour les développeurs, startups et PME souhaitant intégrer des fonctionnalités SMS dans leurs applications. L'application fonctionne comme un serveur local sur smartphone qui reçoit les requêtes API et utilise la carte SIM de l'appareil pour envoyer des SMS réels, éliminant ainsi les frais élevés des services traditionnels.",
      en: "SMSGatewayEmulator is a mobile application developed with React Native and Expo that emulates expensive commercial SMS gateways like Twilio and Vonage. This solution offers an economical alternative for developers, startups and SMEs wanting to integrate SMS features into their applications. The application works as a local server on a smartphone that receives API requests and uses the device's SIM card to send real SMS, thus eliminating the high fees of traditional services."
    },
    features: {
      fr: [
        "Serveur HTTP intégré pour recevoir les requêtes API",
        "Émulation des API Twilio, Vonage et API générique",
        "Modèle freemium avec différents niveaux d'abonnement (Gratuit, Premium, Business, Entreprise)",
        "Journalisation avancée et statistiques d'utilisation",
        "Support multi-appareils pour les plans supérieurs",
        "Webhooks pour le suivi du statut des messages",
        "Système de templates de messages"
      ],
      en: [
        "Built-in HTTP server to receive API requests",
        "Emulation of Twilio, Vonage and generic APIs",
        "Freemium model with different subscription levels (Free, Premium, Business, Enterprise)",
        "Advanced logging and usage statistics",
        "Multi-device support for higher plans",
        "Webhooks for message status tracking",
        "Message template system"
      ]
    },
    technologies: [
      "React Native avec Expo pour l'application mobile",
      "Spring Boot pour le backend de gestion",
      "PostgreSQL pour la base de données",
      "Stripe pour le système de paiement",
      "React.js pour le portail client web",
      "JWT pour l'authentification",
      "Architecture microservices pour la scalabilité"
    ],
    githubLink: "https://github.com/igorvannel",
    demoLink: "#"
  },
  {
    id: 5,
    title: {
      fr: "DrLove - Application de Motivation et Histoires d'Amour",
      en: "DrLove - Motivation and Love Stories Application"
    },
    description: {
      fr: "Plateforme dédiée aux histoires d'amour et à la motivation personnelle",
      en: "Platform dedicated to love stories and personal motivation"
    },
    image: "/assets/images/project 4.png",
    gallery: [
      "/assets/images/project 4.png",
      "/assets/images/project4-detail1.jpg",
      "/assets/images/project4-detail2.jpg"
    ],
    tags: ["React Native", "Spring Boot", "PostgreSQL", "VPS", "Mobile App"],
    longDescription: {
      fr: "DrLove est une application mobile innovante qui combine histoires d'amour inspirantes et contenus motivationnels pour aider les utilisateurs à développer une vision positive des relations et de la vie. L'application offre une bibliothèque d'histoires d'amour authentiques, des conseils relationnels personnalisés, et des citations motivationnelles quotidiennes. Conçue pour créer une communauté bienveillante, DrLove permet également aux utilisateurs de partager leurs propres expériences et de se soutenir mutuellement.",
      en: "DrLove is an innovative mobile application that combines inspiring love stories and motivational content to help users develop a positive vision of relationships and life. The application offers a library of authentic love stories, personalized relationship advice, and daily motivational quotes. Designed to create a caring community, DrLove also allows users to share their own experiences and support each other."
    },
    features: {
      fr: [
        "Bibliothèque d'histoires d'amour vérifiées et classées par catégories",
        "Système de recommandation personnalisé selon les préférences utilisateur",
        "Notifications quotidiennes de motivation et conseils relationnels",
        "Communauté interactive permettant le partage d'expériences",
        "Mode hors-ligne pour accéder au contenu sans connexion",
        "Système de favoris et de marque-pages pour sauvegarder le contenu préféré"
      ],
      en: [
        "Library of verified love stories categorized by themes",
        "Personalized recommendation system based on user preferences",
        "Daily motivational notifications and relationship advice",
        "Interactive community allowing experience sharing",
        "Offline mode to access content without connection",
        "Favorites and bookmarks system to save preferred content"
      ]
    },
    technologies: [
      "React Native pour l'application mobile cross-platform",
      "Spring Boot pour le backend RESTful",
      "PostgreSQL pour la persistance des données",
      "JWT pour l'authentification sécurisée",
      "Architecture microservices",
      "Déploiement sur serveur VPS avec configuration haute disponibilité"
    ],
    githubLink: "https://github.com/igorvannel/",
    demoLink: "#"
  }
];